import { common } from './Common/Common.i18n.ja'
import { create } from './Create/Create.i18n.ja'
import { list } from './List/List.i18n.ja'
import { update } from './Update/Update.i18n.ja'
import { userTypeModal } from './UserTypeModal/UserTypeModal.i18n.ja'

export const admins = {
  list,
  create,
  update,
  userTypeModal,
  common,
}
